import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import Yup from 'yup';
import MainTitle from 'base/components/MainTitle/index';
import SubmitButton from 'base/components/forms/SubmitButton';
import FormikInputField from 'base/components/forms/formik/FormikInputField';
import { createRole } from 'auth/store/roles/actions';
import { closeModal } from 'modal/store/actions';


const CreateRoleForm = ({errors, isSubmitting}) => ( // eslint-disable-line
  <Form>
    <Field
      type="text"
      name="name"
      placeholder="Name"
      component={FormikInputField}
      autoFocus
    />
    <SubmitButton type="submit" disabled={isSubmitting}>
        Create Role
    </SubmitButton>
  </Form>
);


const CreateRoleModal = ({
  name, createRole, closeModal,
}) => (
  <>
    <MainTitle withRoleBelow>New Role</MainTitle>

    <Formik
      initialValues={{
        name: '',
      }}
      validationSchema={
            Yup.object().shape({
              name: Yup.string()
                .required('Name is required.'),
            })
          }
      render={CreateRoleForm}
      onSubmit={(values) => {
        const role = {
          name: values.name,
        };
        createRole(role);
        closeModal(name);
      }}
    />
  </>
);
CreateRoleModal.propTypes = {
  name: PropTypes.string.isRequired,
  createRole: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  createRole,
  closeModal,
};

export default connect(
  null,
  mapDispatchToProps,
)(CreateRoleModal);
